import { render } from "./IAP.vue?vue&type=template&id=f410222c&scoped=true&ts=true"
import script from "./IAP.vue?vue&type=script&lang=ts"
export * from "./IAP.vue?vue&type=script&lang=ts"

import "./IAP.vue?vue&type=style&index=0&id=f410222c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/studiostvapp/studiostvapp/PlatformStudiosApp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f410222c"]])

export default __exports__